import React, { useRef, useState, useCallback } from "react";
import { ButtonContained, CustomText } from "../../../components";
import Webcam from "react-webcam";
import Styles from "../styles/StylesForm";
import { customModal } from "../../../components/modals/utils";
import { fonts } from "../../../config";
import { alerts } from "../../../utils";
import { FormHelperText } from "@material-ui/core";
import { VideocamOff } from "@material-ui/icons";

const getImageSize = async (dataUri) => {
  const byteString = atob(dataUri.split(",")[1]);
  const mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });
  return blob.size / 1024;
};

function WebcamModal({ onSubmit }) {
  const webcamRef = useRef<
    | (Webcam & {
        getScreenshot: () => string;
      })
    | null
  >(null);
  const [imgSrc, setImgSrc] = useState<{ src: string; name: string } | null>(
    null
  );
  const [resImage, setResImage] = useState<number>(1);
  const [isCameraEnabled, setIsCameraEnabled] = useState(false);

  const capture = useCallback(async () => {
    if (webcamRef?.current) {
      let correctSize = true;
      while (correctSize) {
        if (resImage <= 0.05) {
          setResImage(0.05);
          correctSize = false;
        }
        const imageSrc = webcamRef?.current?.getScreenshot();
        const size = await getImageSize(imageSrc);
        if (size <= 60 && size >= 10) {
          correctSize = false;
          setImgSrc({ src: imageSrc!, name: "user-photo" });
        } else {
          setResImage((prev) => (size > 60 ? prev - 0.01 : prev + 0.005));
        }
      }
    }
  }, [webcamRef, resImage]);

  const sendData = () => {
    customModal.close();
    onSubmit(imgSrc);
  };

  // const savePcPhoto = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     if (file.size > 3 * 1024 * 1024) {
  //       alerts.alertWarning("Arquivo deve ser inferior a 3Mb");
  //     } else {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         setImgSrc({ src: e.target.result, name: file.name });
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   }
  // };

  const renderCapturedImage = () => (
    <div style={styles.container}>
      <div style={styles.instructions}>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Priorize fundos simples, de
          preferência branco e sem luzes;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Enquadre bem a região do seu
          rosto, acima do peitoral e ombros;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Evite luzes superiores que causem
          projeções de sombra em seu rosto;
        </div>
      </div>
      <div
        style={{
          ...styles.imagePreview,
          backgroundImage: imgSrc ? `url(${imgSrc.src})` : ""
        }}
      />
      <div style={styles.actions}>
        <Styles.BackPhoto fullWidth={false} onClick={() => setImgSrc(null)}>
          Voltar
        </Styles.BackPhoto>
        <Styles.SendPhoto fullWidth={false} onClick={sendData}>
          Confirmar
        </Styles.SendPhoto>
      </div>
    </div>
  );

  const renderCamera = () => (
    <div style={styles.container}>
      <div style={styles.instructions}>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Priorize fundos simples, de
          preferência branco e sem luzes;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Enquadre bem a região do seu
          rosto, acima do peitoral e ombros;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Evite luzes superiores que causem
          projeções de sombra em seu rosto;
        </div>
      </div>
      {!isCameraEnabled && (
        <div style={styles.cameraDisabled}>
          <VideocamOff style={styles.icon} />
        </div>
      )}
      <Webcam
        mirrored
        screenshotQuality={resImage}
        screenshotFormat="image/jpeg"
        style={{
          ...styles.webcam,
          display: isCameraEnabled ? "block" : "none"
        }}
        audio={false}
        ref={webcamRef}
        onUserMedia={() => setIsCameraEnabled(true)}
        onUserMediaError={() => setIsCameraEnabled(false)}
      />
      <div style={styles.actions}>
        <Styles.BackPhoto fullWidth={false} onClick={customModal.close}>
          Voltar
        </Styles.BackPhoto>
        <Styles.SendPhoto fullWidth={false} onClick={capture}>
          Carregar Foto
        </Styles.SendPhoto>
      </div>
    </div>
  );

  return imgSrc?.src ? renderCapturedImage() : renderCamera();
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    paddingInline: "20px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center"
  },
  instructions: {
    marginBottom: "10px",
    marginLeft: "5px",
    textAlign: "left",
    color: "white"
  },
  bulletPoint: {
    display: "flex",
    marginBottom: "5px"
  },
  bullet: {
    marginRight: "5px",
    fontSize: "16px"
  },
  imagePreview: {
    borderRadius: "5px",
    maxHeight: "80vh",
    minHeight: "300px",
    maxWidth: "80vw",
    height: "100%",
    width: "400px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain"
  },
  cameraDisabled: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#8D9B9C",
    borderRadius: "5px",
    maxHeight: "80vh",
    maxWidth: "80vw",
    height: "100%",
    width: "400px",
    minHeight: "300px"
  },
  icon: {
    fontSize: "48px",
    color: "#fff"
  },
  webcam: {
    borderRadius: "5px",
    maxHeight: "80vh",
    maxWidth: "80vw",
    height: "100%",
    width: "400px",
    minHeight: "300px"
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingTop: "10px",
    gap: "8px",
    width: "100%"
  }
};

export default WebcamModal;
